import { email_regex } from "../consts/regex";

import axios from "axios";

var email = "";
jQuery(document).ready(function ($) {
  //detect email changes to validate the input
  $("#newsletter-subscribe-email").on("input focus keyup", function (e) {
    email = e.target.value;

    if (email.endsWith(" ") || email.startsWith(" ")) {
      email = email.replace(" ", "");
    }

    switch (true) {
      case !email:
        $("#newsletter-subscribe-submit-btn").prop("disabled", true);
        $("#newsletter-subscribe-submit-btn").attr("disabled", true);
        break;
      case !email_regex.test(email):
        $("#newsletter-subscribe-submit-btn").prop("disabled", true);
        $("#newsletter-subscribe-submit-btn").attr("disabled", true);
        break;
      default:
        $("#newsletter-subscribe-submit-btn").prop("disabled", false);
        $("#newsletter-subscribe-submit-btn").attr("disabled", false);
        break;
    }
  });

  $("#form__newsletter").on("submit", function (e) {
    e.preventDefault();
    $("#newsletter-subscribe-submit-btn").addClass("button--loading");
    join_newsletter(email);
  });

  function join_newsletter(email) {
    let apiUrl = savedSettings?.api_url ?? "";
    let xAPIKey = savedSettings?.x_api_key ?? "";

    const url = `${apiUrl}/joinNewsletter`;
    const body = {
      email: email,
      mailerTemplateID: "d-ee63423d7e8b4faf83956ca38f780731",
      submitLeadCampaignName: "newsletter",
      source: "footer",
    };

    axios
      .post(url, body, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": xAPIKey,
        },
      })
      .then(() => {
        $("#newsletter-subscribe-submit-btn").removeClass("button--loading");
        $("#newsletter-subscribe-email").val("");
        $("#newsletter-subscribe-submit-btn").attr("disabled", true);
        $("#newsletter-success-popup").addClass("is-active");
        setTimeout(() => {
          $("#newsletter-success-popup").removeClass("is-active");
        }, 5000);
      })
      .catch((err) => {
        $("#newsletter-subscribe-submit-btn").removeClass("button--loading");
        console.log(err);
      });
  }

  $("#newsletter-success-popup button").on("click", function (e) {
    e.preventDefault();
    $("#newsletter-success-popup").removeClass("is-active");
  });
});
